import {
  AppContentLayoutNav,
  ContentWidth,
  FooterType,
  HorizontalNavType,
  NavbarType,
} from "@layouts/enums";
import { VIcon } from "vuetify/components";

export const layoutConfig = {
  app: {
    title: "my-layout",
    logo: h("img", { src: "@images/aspial_logo.png" }),
    // logo: logo,
    contentWidth: ContentWidth.Boxed,
    contentLayoutNav: AppContentLayoutNav.Vertical,
    // Set to 0 so the overlay-nav breakpoint never triggers — this admin always
    // uses a persistent sidebar regardless of viewport width.
    overlayNavFromBreakpoint: 0,

    // isRTL: false,
    i18n: {
      enable: true,
    },
    iconRenderer: VIcon,
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: {
    type: FooterType.Static,
  },
  verticalNav: {
    isVerticalNavCollapsed: false,
    defaultNavItemIconProps: { icon: "ri-circle-line" },
  },
  horizontalNav: {
    type: HorizontalNavType.Sticky,
    transition: "none",
    popoverOffset: 0,
  },
  icons: {
    chevronDown: { icon: "ri-arrow-down-line" },
    chevronRight: { icon: "ri-arrow-right-line" },
    close: { icon: "ri-close-line" },
    verticalNavPinned: { icon: "ri-record-circle-line" },
    verticalNavUnPinned: { icon: "ri-circle-line" },
    sectionTitlePlaceholder: { icon: "ri-subtract-line" },
  },
};
